<template>
  <div class="LinksComponent">
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(item, i) in items"
        :key="i"
      >
        <v-expansion-panel-title :hide-actions="false">
          {{ item.title }}
          <i class="icon-plus-01"></i>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <p class="text">{{ item.text }}</p>
          <a
            :href="item.link"
            target="_blank"
          >
            {{ item.linkText }}
          </a>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup lang="ts">
interface PropsInterface {
  items: any
}
withDefaults(defineProps<PropsInterface>(), {})
</script>

<style lang="scss" scoped>
.LinksComponent {
  all: unset;

  :deep(.v-expansion-panels) {
    .v-expansion-panel__shadow {
      box-shadow: $box-shadow-none;
    }

    .v-expansion-panel-title {
      color: $color-primary-dark;
      font-weight: $font-weight-500;
      font-size: $font-size-m;

      .v-expansion-panel-title__overlay {
        background-color: $color-neutral-00;
        opacity: 0;
      }

      .v-expansion-panel-title__icon {
        display: none;
      }

      i::before {
        font: normal normal normal 20px/1 $font-family-icons;
      }
    }

    .v-expansion-panel-title--active {
      background-color: $color-neutral-00;

      i::before {
        content: var(--icon-minus-03);
      }
    }

    .v-expansion-panel-text__wrapper {
      margin-bottom: $spacing-xs;
      padding: 0 $spacing-xl;

      .text {
        margin-bottom: $spacing-s;
        color: $color-neutral;
      }
    }
  }
}
</style>
